// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-avatar[data-v-36449da1]{background-color:transparent}.el-aside[data-v-36449da1]{color:#9da8ae;background-color:#1b3446;transition:all .2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;max-width:210px}.el-header[data-v-36449da1]{display:flex;align-items:center;padding:0;border-right:1px solid #e8eaeb}.el-menu[data-v-36449da1]{border-right:none}.el-menu-item[data-v-36449da1]{background-color:#1b3446;color:#9da8ae}", ""]);
// Exports
module.exports = exports;
